import { AboutHighlight } from '../models/about-highlight.model';

export const ABOUT_HIGHLIGHTS: AboutHighlight[] = [
  {
    icon: '🎯',
    title: 'Student-Centered Learning',
    description: 'Every feature, every lesson, every tool is designed with one goal: helping you achieve your maximum potential and academic success.'
  },
  {
    icon: '🌟',
    title: 'Excellence in Education',
    description: 'We maintain the highest standards in digital education, ensuring every student receives world-class learning experiences.'
  },
  {
    icon: '🤝',
    title: 'Community & Support',
    description: 'Join a vibrant community of learners, with dedicated teachers and support staff committed to your educational success.'
  }
];
